<div class="main-container">
  <div class="scroll-progress"></div>
  <header role="banner" *ngIf="showHeader">
    <div class="header-container">
      <a routerLink="" class="logo">
       <img src="/assets/header_icon.png" class="logo-image" alt="Universe Dynamic logo" width="75" height="28" />
      </a>
      <div class="nav-container">
        <nav role="navigation" aria-label="Main navigation">
          <ul class="nav-links">
            <li *ngFor="let link of navLinks">
              <a
                [routerLink]="link.route"
                (click)="link.route === '/pricing' ? onPricingLinkClick() : null"
              >
                {{ link.label | translate }}
              </a>
            </li>
            <li>
              <a routerLink="/active-code" class="nav-activate-code">
                {{ 'common.ACTIVATE_CODE' | translate }}
              </a>
            </li>
          </ul>
        </nav>
      </div>
      <div class="btn-wrap">
        <div class="cart-group" (click)="onCartClick()">
          <!-- Default cart icon (when not scrolled) -->
          <span class="cart-icon-wrapper" *ngIf="!isScrolled()">
            <img src="/assets/cart_white.svg" alt="Shopping cart" width="18" height="18" />
            <span class="cart-badge" *ngIf="hasPricingWizardState || hasProductInCart">1</span>
          </span>
          <!-- New cart icon (when scrolled up) -->
          <span class="cart-icon-wrapper"  *ngIf="isScrolled()">
            <img src="/assets/cart_pricing.png" alt="Shopping cart" width="18" height="18" />
            <span class="cart-badge" *ngIf="hasPricingWizardState || hasProductInCart">1</span>
          </span> 
          <p class="cart-text">{{ 'common.CART' | translate }}</p>
        </div>
        <a *ngIf="!isLoggedIn()" href="https://app.messagefromheaven.com" class="header-cta">{{
          'common.LOGIN' | translate
        }}</a>
        <a *ngIf="isLoggedIn()" routerLink="/dashboard/home" class="header-cta">{{ 'common.PANEL' | translate }}</a>
        <div class="language-selector">
          <div class="language-dropdown" [class.open]="languageMenuOpen">
            <button
              class="language-button"
              (click)="toggleLanguageMenu()"
              id="languageButton"
              [attr.aria-label]="'common.LANGUAGE_SELECTOR' | translate"
            >
              <img
                [src]="selectedLanguage.flag"
                alt=""
                class="flag-icon"
                width="24"
                height="16"
              />
              <span>{{ selectedLanguage.display }}</span>
              <!-- <span class="language-arrow" style=" font-weight: 400;">﹀</span> -->
              <img src="/assets/dropdown_arrow.png" alt="" class="arrow-icon" width="8" height="5" />
            </button>

            <div class="language-menu" id="languageMenu" *ngIf="languageMenuOpen">
              <div
                class="language-option"
                *ngFor="let lang of languages"
                [class.active]="lang.code === selectedLanguage.code"
                (click)="selectLanguage(lang)"
              >
                <span class="language-left">
                  <img [src]="lang.flag" alt="" class="flag-icon-menu" width="24" height="16" />
                  {{ lang.full }}
                </span>
                <span class="language-code">{{ lang.display }}</span>
              </div>
            </div>
          </div>
        </div>

        <!-- Mobile Menu Toggle Button -->
        <button
          class="mobile-menu-toggle"
          (click)="toggleMobileMenu()"
          [class.active]="isMobileMenuOpen()"
          aria-label="Toggle mobile menu"
        >
          <!-- <span class="hamburger-line"></span>
        <span class="hamburger-line"></span>
        <span class="hamburger-line"></span> -->
          <img src="/assets/menu-icon.svg" alt="Menu" class="menu-icon" width="18" height="18" />
        </button>
      </div>
    </div>
  </header>

  <!-- Mobile Off-Canvas Menu -->
  <!-- <div class="mobile-menu-overlay" [class.active]="isMobileMenuOpen()" (click)="closeMobileMenu()"></div> -->
  <nav
    class="mobile-menu"
    [class.active]="isMobileMenuOpen()"
    [class.scrolled]="isScrolled()"
    role="navigation"
    aria-label="Mobile navigation"
  >
    <div class="mobile-menu-header">
      <a routerLink="" class="mobile-logo" (click)="closeMobileMenu()" aria-label="Universe Dynamic Home">
        <img src="/assets/header_icon.png" class="mobile-icon" />
      </a>
      <button class="mobile-menu-close" (click)="closeMobileMenu()" aria-label="Close mobile menu">
        <span class="close-icon">
          <img src="/assets/menu-cross-icon.svg" alt="Close" width="17" height="17">
        </span>
      </button>
    </div>
    <ul class="mobile-nav-links">
      <li *ngFor="let link of navLinks">
        <a
          [routerLink]="link.route"
          (click)="link.route === '/pricing' ? onPricingLinkClick() : null; closeMobileMenu()"
        >
          {{ link.label | translate }}
        </a>
      </li>
      <li>
        <a routerLink="/active-code" class="nav-activate-code" (click)="closeMobileMenu()">
          {{ 'common.ACTIVATE_CODE' | translate }}
        </a>
      </li>
      <!-- <li class="mobile-login-item">
        <a routerLink="/login" class="header-cta" (click)="closeMobileMenu()">🔐 {{ 'common.LOGIN' | translate }}</a>
      </li> -->
    </ul>

    <div class="mobile-bottom-row">
      <div class="mobile-login-item">
        <a *ngIf="!isLoggedIn()" href="https://app.messagefromheaven.com" class="header-cta" (click)="closeMobileMenu()">
          {{ 'common.LOGIN' | translate }}
        </a>
        <a
          *ngIf="isLoggedIn()"
          routerLink="/dashboard/home"
          class="header-cta"
          (click)="closeMobileMenu()"
        >
          {{ 'common.PANEL' | translate }}
        </a>
      </div>

      <div class="mobile-language-selector">
        <div class="mobile-language-dropdown" [class.open]="languageMenuOpen">
          <button
            class="mobile-language-button"
            (click)="toggleLanguageMenu(); $event.stopPropagation()"
            [attr.aria-label]="'common.LANGUAGE_SELECTOR' | translate"
          >
            <img [src]="selectedLanguage.flag" alt="" class="flag-icon" width="24" height="16" />
            <span>{{ selectedLanguage.display }}</span>
            <span class="language-arrow" style="font-weight: 400">﹀</span>
            <!-- <img src="/assets/lang-drop-arrow.svg" alt="Arrow Down" class="arrow-icon" /> -->
          </button>
          <div class="mobile-language-menu" *ngIf="languageMenuOpen">
            <div
              class="language-option"
              *ngFor="let lang of languages"
              [class.active]="lang.code === selectedLanguage.code"
              (click)="selectLanguage(lang); $event.stopPropagation()"
            >
              <span class="language-left">
                <img [src]="lang.flag" alt="" class="flag-icon-menu" width="24" height="16" />
                {{ lang.full }}
              </span>
              <span class="language-code">{{ lang.display }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </nav>

  <!-- Mobile Language Selection Modal -->
  <div class="mobile-language-modal-overlay" *ngIf="showMobileLanguageModal" (click)="closeMobileLanguageModal()">
    <div class="mobile-language-modal" (click)="$event.stopPropagation()">
      <!-- Modal Header -->


      <!-- Modal Title -->
      <h2 class="mobile-language-modal-title">{{ 'common.ALL_LANGUAGES' | translate }}</h2>

      <!-- Language Selection Container -->
      <div class="mobile-language-selection-container">
        <!-- Search Bar -->
        <div class="mobile-language-search">
          <svg class="search-icon" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9 17C13.4183 17 17 13.4183 17 9C17 4.58172 13.4183 1 9 1C4.58172 1 1 4.58172 1 9C1 13.4183 4.58172 17 9 17Z" stroke="#9ca3af" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M19 19L14.65 14.65" stroke="#9ca3af" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          <input
            type="text"
            class="mobile-language-search-input"
            [placeholder]="'common.SEARCH' | translate"
            [(ngModel)]="languageSearchQuery"
            (input)="$event.stopPropagation()"
          />
        </div>

        <!-- Language List -->
        <div class="mobile-language-list">
          <div
            class="mobile-language-item"
            *ngFor="let lang of getFilteredLanguages()"
            [class.selected]="lang.code === selectedLanguage.code"
            (click)="selectLanguage(lang)"
          >
            <div class="mobile-language-item-content">
              <img [src]="lang.flag" [alt]="lang.display" class="mobile-language-flag" />
              <span class="mobile-language-name">{{ lang.full }}</span>
            </div>
            <div class="mobile-language-radio">
              <div class="mobile-radio-circle" [class.selected]="lang.code === selectedLanguage.code">
                <div class="mobile-radio-inner" *ngIf="lang.code === selectedLanguage.code">
                  <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                    <path d="M10 3L4.5 8.5L2 6" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
